<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Forgot Password v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <!-- logo -->
          <!-- <vuexy-logo /> -->
          <img
            style="width: 100px;"
            src="../../assets/images/logo/LogoVls.png"
          >

          <h2 class="brand-text text-primary ml-1" />
        </b-link>

        <b-card-title class="mb-1">
          Recuperar Senha 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          Digite seu e-mail e nós lhe enviaremos instruções para redefinir sua senha
        </b-card-text>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form
            class="auth-forgot-password-form mt-2"
            @submit.prevent="validationForm"
          >
            <!-- email -->
            <b-form-group
              label="Email"
              label-for="forgot-password-email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="forgot-password-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false : null"
                  name="forgot-password-email"
                  placeholder="john@example.com"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              block
              type="submit"
            >
              Enviar link de redefinição
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <b-link :to="{ name: 'auth-login' }">
            <feather-icon icon="ChevronLeftIcon" /> Voltar ao login
          </b-link>
        </b-card-text>

      </b-card>
      <!-- /Forgot Password v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BCard, BLink, BCardText, BCardTitle, BFormGroup, BFormInput, BForm, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import PassWordService from '@/services/RedefirSenha'

export default {
  components: {
    VuexyLogo,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      EmailData: JSON.parse(localStorage.getItem('EmailData')),
      verifyUser: '',
      userEmail: '',
      // validation
      required,
      email,
    }
  },
  methods: {
    async  validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.Password()
          const EmailData = this.userEmail
          console.log(' EmailData ', success, this.EmailData)
          localStorage.setItem('EmailData', JSON.stringify(EmailData))
        }
      })
    },
    async Password() {
      await PassWordService.ChangePassword(this.userEmail)
        .then(response => {
          const verifyUser = response.data.auth === true ? 'Autorizado' : 'null'
          if (verifyUser === 'Autorizado') {
            this.$router.push({ name: 'verificarEmail' })
          }
        })
        .catch(error => {
          console.log('error', error)
        })
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
